const currentTime = new Date();
const messages =
{
    en: {
        client: {
            action: {
                create: 'New Client',
                edit: 'Edit Client',
                view: 'View Client',
            },
            message: {
                client_users: 'Client Users',
            },
        },
        client_user: {
            action: {
                create: 'New Client User',
                edit: 'Edit Client User',
                view: 'View Client User',
            },
        },
        dashboard: {
            message: {
                introduction: 'Please use the menu on the left to navigate the system',
            },
        },
        domain: {
            action: {
                create: 'New Domain',
                edit: 'Edit Domain',
            },
            field: {
                managed: 'Managed',
                registrar: 'Registrar',
                renew: 'Renew',
            },
        },
        footer: {
            message: {
                copyright: `© Vertical Plus ${ currentTime.getFullYear() }`,
            },
        },
        general: {
            action: {
                cancel: 'Cancel',
                close: 'Close',
                delete: 'Delete',
                edit: 'Edit',
                no: 'No',
                ok: 'Ok',
                open: 'Open',
                yes: 'Yes',
            },
            error: {
                communication_error: 'Communication Error',
                communication_error_contact: 'If the problem persists please contact support.',
                communication_error_description: 'There\'s a problem with your connection to the server.',
                failed_deleting_not_found: 'Failed deleting - the item could not be found',
                failed_deleting_server_error: 'Failed deleting - please contact support if this continues',
                failed_duplicating_server_error: 'Failed duplicating - please contact support if this continues',
                failed_loading_not_found: 'Failed loading - the item could not be found',
                failed_loading_server_error: 'Failed loading - please contact support if this continues',
                failed_saving_invalid_details: 'Failed saving due to invalid details',
                failed_saving_server_error: 'Failed saving - please contact support if this continues',
                passwords_must_match: 'The passwords must match',
                somethings_gone_wrong: 'Something\'s gone wrong. Please refresh and try again.',
            },
            field: {
                account_manager: 'Manager',
                active: 'Active',
                address: 'Address',
                archived: 'Archived',
                ascending: 'Ascending',
                assignment: 'Assignment',
                basic_details: 'Basic Details',
                categorisation: 'Categorisation',
                client: 'Client',
                client_user: 'Client User',
                comments: 'Comments',
                county: 'County',
                date: 'Date',
                date_created: 'Created',
                date_expiry: 'Expiry',
                deadline: 'Deadline',
                deleted: 'Deleted',
                descending: 'Descending',
                disabled: 'Disabled',
                email: 'Email',
                enabled: 'Enabled',
                first_name: 'First Name',
                from: 'From',
                id: 'Id',
                image: 'Image',
                job: 'Job',
                last_name: 'Last Name',
                line_1: 'Line 1',
                line_2: 'Line 2',
                location: 'Location',
                manager: 'Manager',
                milestone: 'Milestone',
                name: 'Name',
                notes: 'Notes',
                omnisearch: 'Omni Search',
                other: 'Other',
                password: 'Password',
                password_confirmation: 'Password (Confirmation)',
                postcode: 'Postcode',
                schedule: 'Schedule',
                stage: 'Stage',
                status: 'Status',
                tags: 'Tags',
                task: 'Task',
                tasks: 'Tasks',
                techspec: 'Techspec',
                text: 'Text',
                time: 'Time',
                to: 'To',
                total: 'Total',
                town: 'Town',
                type: 'Type',
                url: 'URL',
                user: 'User',
                username: 'Username',
            },
            message: {
                app_title: 'V+ Admin',
                contact_us: 'Contact Us',
                delete_confirmation_title: 'Are you sure?',
                delete_confirmation_message: 'Do you really want to delete this item?',
                deleted: 'Deleted',
                details: 'Details',
                duplicated_successfully: 'Duplicated successfully',
                no_options_available: 'No options available',
                not_logged_in: 'You are not logged in',
                please_enter_description: 'Please enter a valid description',
                please_enter_name: 'Please enter a valid name',
                please_enter_title: 'Please enter a valid title',
                saved_successfully: 'Saved successfully',
                settings_saved: 'Settings saved',
                site_title: '',
                warning: 'Warning',
                welcome_back_name: 'Welcome back {name}',
                welcome_name: 'Welcome {name}',
            },
        },
        home: {
            messages: {
                title: 'Welcome to V+ Admin',
            },
        },
        invoice: {
            action: {
                create: 'New Invoice',
                edit: 'Edit Invoice',
                view: 'View Invoice',
            },
            field: {
                adwords_amount: 'Adwords Amount',
                amount: 'Amount',
                date_credit_note: 'Credit Note',
                date_paid: 'Paid',
                date_reminder_1: 'Reminder 1',
                date_reminder_2: 'Reminder 2',
                date_requested: 'Requested',
                date_sent: 'Sent',
                domain: 'Domain',
                misc_amount: 'Misc Amount',
                number: 'Number',
                payment_terms: 'Payment Terms',
                sent: 'Sent',
                service: 'Service',
            },
        },
        job: {
            action: {
                add_contribution: 'Add Contribution',
                add_task: 'Add Task',
                create: 'New Job',
                duplicate: 'Duplicate Job',
                edit: 'Edit Job',
                make_private: 'Make Private',
                open_in_jira: 'Open in Jira',
                view: 'View Job',
            },
            error: {
                failed_duplicating_job: 'Failed duplicating job - please contact technical if this continues',
                failed_saving_contribution: 'Failed saving contribution - please contact technical if this continues',
                failed_saving_timesheet: 'Failed saving timesheet - please contact technical if this continues',
            },
            field: {
                add_timesheet: 'Add Timesheet',
                amount: 'Amount',
                assigned_by: 'Assigned By',
                assigned_to: 'Assigned To',
                attachment: 'Attachment',
                attachment1: 'Attachment 1',
                attachment2: 'Attachment 2',
                attachment3: 'Attachment 3',
                attachment4: 'Attachment 4',
                attachment5: 'Attachment 5',
                category: 'Category',
                chase_partner: 'Chase Partner',
                client_visible: 'Visble to Client',
                code: 'Code',
                complete: 'Complete',
                contributions: 'Contributions',
                customer_satisfaction_level: 'Customer Satisfaction Level',
                date_scheduled: 'Date Scheduled',
                jira_link: 'Jira Link',
                job_owner: 'Job Owner',
                parent_job: 'Parent Job',
                priority: 'Priority',
                reason: 'Reason',
                roi_amount: 'ROI Amount',
                roi_level: 'ROI Level',
                stage: 'Stage',
                start_date: 'Start Date',
                techspec_owner: 'Techspec Owner',
                ticket: 'Ticket',
                workflow: 'Workflow',
            },
            message: {
                duplicate_confirmation_message: 'Are you sure you want to duplicate this job?',
                duplicate_confirmation_title: 'Duplicate',
                duplicated_successfully: 'Job was duplicated successfully',
            },
        },
        meeting: {
            action: {
                create: 'New Meeting',
                edit: 'Edit Meeting',
                new_client_job: 'New Client Job',
                new_vertical_job: 'New V+ Job',
                view: 'View Meeting',
            },
            field: {
                added_by: 'Added By',
                jobs: 'Jobs',
                meeting_date: 'Meeting Date',
                meeting_location: 'Meeting Location',
                meeting_notes: 'Meeting Notes',
            },
            message: {
                location_client: 'Client',
                location_other: 'Other',
                location_vertical_plus: 'Vertical Plus',
                notes_saved: 'Synced',
                notes_updating: '...syncing',
            },
        },
        navbar: {
            message: {
                calendar: 'Calendar',
                clients: 'Clients',
                configuration: 'Configuration',
                dashboard: 'Dashboard',
                domains: 'Domains',
                home: 'Home',
                invoices: 'Invoices',
                jobs: 'Jobs',
                meetings: 'Meetings',
                services: 'Services',
                settings: 'Settings',
                techspecs: 'Techspecs',
                timesheets: 'Timesheets',
            },
        },
        service: {
            action: {
                create: 'New Service',
                edit: 'Edit Service',
            },
            field: {
                domain: 'Domain',
                invoice_amount: 'Invoice Amount',
                renew: 'Renew',
            },
        },
        techspec: {
            action: {
                choose_duplication_client: 'Choose client for duplicate',
                create: 'New Techspec',
                duplicate: 'Duplicate Techspec',
                edit: 'Edit Techspec',
                view: 'View Techspec',
            },
            field: {
                milestones: 'Milestones',
                target_client: 'Target Client',
            },
        },
        timesheet: {
            field: {
                activity: 'Activity',
                break: 'Break',
                breakdown: 'Breakdown',
                chargeable: 'Chargeable',
                daily: 'Daily',
                lunch: 'Lunch',
                monthly: 'Monthly',
                weekly: 'Weekly',
            },
            error: {
                must_be_after_from: 'Must be after from',
            },
        },
    },
};

export default messages;